import { useCallback } from 'react';
import useAjaxRequest from './useAjaxRequest';
import { URL_PROPOSAL } from '../config/endpoints';

const useProposal = () => {
  const {
    response: { loading, data: proposal },
    performRequest,
  } = useAjaxRequest();

  const getProposal = useCallback(
    proposalId =>
      performRequest({
        method: 'post',
        url: URL_PROPOSAL(),
        headers: {
          'X-Remetente': 'LOJA',
          'X-Evento-Versao': '2.0',
        },
        data: {
          identificacao: {
            codigoCotacao: `${proposalId}`,
          },
          cobranca: {
            tpCaptura: 'GATEWAY',
            confGateway: {
              urlRetorno: `${window.location.origin}/capitalizacao/pagamento`,
              versao: 'v1',
            },
          },
        },
      }),
    [performRequest]
  );
  return { loading, getProposal, proposal };
};

export default useProposal;
